<template>
  <div id="app">
    <div>
      <header-el></header-el>
      <div class="mt30 intro-content">
     <div class="item-warp">
         <div class="item"><div class="item-bar" @mouseover="d_iconindex=1" @mouseout="d_iconindex==0" @click="itemclick('1')"><span>我们的原则</span> <span v-bind:class="{'icon-kaistart-direction-down':d_iconindex==1,'icon-kaistart-direction-up':d_itemshow==1}"></span></div>
         <div transition="expand" class="item-content" style="display:none;" v-show="d_itemshow==1"><p>在踏浪吧，任何想法、设计或是艺术作品，都可以作为项目提交。每个的项目都有以下规则需要遵守：</p>
        <p>
        <b>·项目必须对支持者有回报物</b>
        <br>
        项目发起者应该对支持者承诺实物回报，类似于：“我成功了。这就是我的创意。请与我一起分享它吧。”</p>
        <p><b>·对于项目的描述必须诚实和清楚。</b><br>我们的机制是建立信任基础上的。发起者对于项目的描述不能歪曲事实，或者误导事实，如果存在风险或困难应该直言不讳。当你的创意还涉及到生产、销售，我们规定你必须展示出原型机的真实产品图片，而不是效果图。</p>
        <p><b>·我们目前不支持公益类项目。</b><br>我们知道有很多创意和社会公益相关。但因为目前的现状，我们的平台不支持为公益机构或公益项目募集资金的项目。<br>这些规则不能覆盖所有可能的应用场景，但它们可以帮助你理解我们的目的。</p>
        <p class="">关于踏浪吧，你有更多问题？我们会在这里帮助你。</p></div>

      </div></div>

        <div class="item"><div class="item-bar"  @mouseover="d_iconindex=2" @mouseout="d_iconindex=0" @click="itemclick('2')"><span>信任机制</span> <span  v-bind:class="{'icon-kaistart-direction-down':d_iconindex==2,'icon-kaistart-direction-up':d_itemshow==2}"></span></div>
         <div transition="expand" class="item-content" style="display:none;" v-show="d_itemshow==2"><p>踏浪吧的目标是提供一个安全、可信的平台，希望所有人都是诚实和公开的。<br>我们会在踏浪吧建立一个信任系统。我们会筛查项目潜在的风险，会调查大家向我们提出的质疑。但是我们需要提醒，即使拥有这些措施，并不是每个项目都能按照预定的计划完成。</p>
        <p><b>所有人都该知道</b>
          <br>踏浪吧并不是电商。人们不是在这里购买已经存在的商品——我们是在参与创意。创意成真并不总是那么容易，一些项目会完成得很精彩，还有一些会遇到想不到的问题——请对它们保持耐心。</p>
        <p>发起者对他们的项目负责。一旦你支持一个项目，你需要相信发起者可以很好的完成他的工作。你可以对发起者做一点研究，了解他们的经验、名声。支持者也要判断什么是值得支持的。</p>
        <p>一些项目并不会按照计划进行。踏浪吧的项目发起者会在这里详细记录他的计划进展，但是没有事情可以保证。当你支持一个项目，你需要记住这点。</p>
        <p><b>支持者可以</b><br>·仔细阅读项目页面。<br>那里应该有所有你想知道的信息，其中包括项目细节以及谁为项目发起者担保。也别忘了看看评论，看看其他人怎么评价这个项目，也需要看看更新，看看发起者和支持者之间的互动。“风险与挑战”部分特别值得一看。</p>
        <p>·听听别人的意见。<br>如果你还不确定，你可以在网上查询，发起者是否有其他的页面，他之前做过什么项目，人们对他的评价。</p>
        <p>·提问<br>如果你想对一个项目了解更多，向发起者提问。每个项目页面上都会有提问按钮。如果你觉得某个项目有可疑的地方，可在项目页面“报告这个项目”，我们会去核实，是否有人试图滥用我们这个平台。</p>
        <p><b>发起人可以</b><br>开放。</p>
        <p>积极反应。</p>
        <p>诚实。</p></div></div>

        <div class="item"><div class="item-bar" @mouseover="d_iconindex=3" @mouseout="d_iconindex=0" @click="itemclick('3')"><span>我们会做的</span> <span v-bind:class="{'icon-kaistart-direction-down':d_iconindex==3,'icon-kaistart-direction-up':d_itemshow==3}"></span></div>
         <div transition="expand" class="item-content" style="display:none;" v-show="d_itemshow==3">
             <p><b>·了解每个项目</b><br>我们不止是建立这个平台，我们希望它可以健康发展。每个项目提交之后，我们会率先阅读提交的资料，从中寻找优秀的项目，向大家推荐，我们也会指出一些项目中的问题。</p>
          <p><b>·收集大家的反馈</b><br>我们还会随时收集大家对项目的反馈，并且对一些问题进行核实。从而保证项目的安全性。</p></div></div></div>
      </div>
      <div>
        <div class="footer-padding"></div>
        <footer-el></footer-el>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";
export default {
  components: {
    "header-el": Header,
    "footer-el": Footer
  },
  data() {
      return {
          d_itemshow:1,

          d_iconindex:1,
      }
  },
  methods:{
    itemclick:function(index) {
        var t = this
        t.d_itemshow = index

    }
  }
};
</script>

<style scoped>
@import url('../css/about.css');
.item-bar {
     display: -ms-flexbox;
    display: flex;
    font-size: 24px;
    color: #ff3333;
    padding: 30px 0;
    padding-right: 15px;
    -ms-flex-pack: justify;
    justify-content: space-between;
}
.item-bar span{
    font-size:24px;
}
.intro-content p {
    line-height: 1.5;
    font-size: 14px;
    margin: 25px 0;
}
</style>
